import { useEarlyAccess } from '../EarlyAccessContext';

function AnnouncementBanner() {
  const openEarlyAccess = useEarlyAccess();

  const message = "Netwatch MVP launching July–August 2026 — Limited to 5 Pilot Customers — Apply for Early Access Now";

  return (
    <div className="announcement-banner">
      <div className="announcement-track">
        {[...Array(4)].map((_, i) => (
          <span key={i} className="announcement-text">
            <i className="fas fa-rocket"></i> {message}
            <button onClick={openEarlyAccess} className="announcement-cta">Apply Now</button>
            <span className="announcement-separator">★</span>
          </span>
        ))}
      </div>
    </div>
  );
}

export default AnnouncementBanner;
